/* HealthspanX | Consolidated, browser-deferred JavaScript. Original module order and dynamic editor hooks retained. */

/* legacy route bootstrap | document.body && document.body.classList.contains('sf-site') */
if (document.body && document.body.classList.contains('sf-site')) {
/* BEGIN SOURCE legacy route bootstrap */
/* HealthspanX Luminous Field runtime build. Source-preserving consolidation; order-sensitive JS. */
/* BEGIN hsx-runtime-legacy.js: hsx-original.js (1) */
(() => {
  'use strict';
  if (window.hsxOriginalLoaded) return;
  window.hsxOriginalLoaded = true;
  const root = document.documentElement;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const scenes = new Set(), bound = new WeakSet(), reveals = new Set();
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const clamp = n => Math.max(0, Math.min(1, n));
  let frame = 0;
  const staticMode = () => reduced.matches;
  const origins = {one:[.352,.10],two:[.648,.17],three:[.352,.62],four:[.648,.50],five:[.645,.82]};
  function connectors(scene) {
    const svg = $('[data-connectors]', scene), sticky = $('.capsule-scene__sticky', scene), focus = $('.capsule-focus', scene);
    if (!svg || !sticky || !focus) return;
    const r = sticky.getBoundingClientRect();
    if (!r.width || !r.height) return;
    const width = focus.offsetWidth, height = focus.offsetHeight, x = (r.width-width)/2, y = (r.height-height)/2;
    svg.setAttribute('viewBox', `0 0 ${r.width} ${r.height}`);
    Object.entries(origins).forEach(([key,origin]) => {
      const label = $('.capsule-annotation--'+key, scene);
      if (!label) return;
      const lr = label.getBoundingClientRect(), ox = x+origin[0]*width, oy = y+origin[1]*height;
      const ex = label.classList.contains('capsule-annotation--left') ? lr.right-r.left+6 : lr.left-r.left-6;
      const ey = lr.top-r.top+(parseFloat(getComputedStyle(label).lineHeight)||16)/2;
      const path = $(`[data-connector="${key}"]`,svg), dot = $(`[data-origin="${key}"]`,svg);
      if (path) { path.setAttribute('d',`M${ox} ${oy}L${ex} ${ey}`);path.style.setProperty('--line-len',path.getTotalLength()); }
      if (dot) dot.setAttribute('d',`M${ox} ${oy}L${ox} ${oy}`);
    });
  }
  function capsule(scene) {
    const r = scene.getBoundingClientRect();
    if (!staticMode() && (r.bottom < -100 || r.top > innerHeight+100)) return;
    const p = reduced.matches ? .72 : clamp(-r.top/Math.max(1,r.height-innerHeight));
    scene.dataset.sfProgress = String(p);
    const travel = clamp(p/.32), ease = 1-Math.pow(1-travel,3), opening = clamp((p-.32)/.18);
    const values = {'--scene-progress':p,'--scene-x':(-40+ease*40)+'%','--scene-y':(28-ease*28)+'%','--scene-scale':.34+ease*.66,'--scene-rotation':(-12+ease*12)+'deg','--scene-gloss-x':(-85+ease*170)+'%','--scene-gloss-opacity':Math.sin(travel*Math.PI)*.26,'--scene-cell-opacity':1-ease,'--bg-cell-opacity':.7-ease*.15,'--scene-cell-scale':1-ease*.28,'--scene-cell-blur':ease*1.1+'rem','--scene-release-y':clamp((p-.90)/.10)*-8+'svh','--scene-disc-opacity':.35+ease*.65,'--scene-disc-scale':.48+ease*.52,'--scene-cap-lift':opening*14+'%','--scene-bloom-opacity':.28+ease*.5,'--scene-bloom-scale':.72+ease*.58,'--scene-glow':ease*.7+opening*.3};
    for(let i=0;i<5;i++){const start=.42+i*.02;values['--scene-line-'+(i+1)]=clamp((p-start)/.05);values['--scene-label-'+(i+1)+'-clip']=(1-clamp((p-start-.03)/.05))*100+'%';}
    Object.entries(values).forEach(([name,value])=>scene.style.setProperty(name,String(value)));
    connectors(scene);
  }
  function update() {
    frame = 0;
    if (document.hidden) return;
    scenes.forEach(scene => {
      if (!scene.isConnected) { observer?.unobserve(scene); scenes.delete(scene); return; }
      if (scene.matches('[data-capsule-scene]')) capsule(scene);
      else if (scene.matches('[data-parallax]')) {
        if (staticMode()) {scene.style.setProperty('--sf-parallax-y','0px');return;}
        if (scene.dataset.sfInview === 'false') return;
        const r=scene.getBoundingClientRect(),depth=parseFloat(scene.dataset.parallax)||1;
        const y=((r.top+r.height/2-innerHeight/2)/innerHeight)*depth*-20;
        scene.style.setProperty('--sf-parallax-y',Math.max(-24,Math.min(24,y))+'px');
      }
    });
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(update);}
  const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{entries.forEach(e=>e.target.dataset.sfInview=String(e.isIntersecting));schedule();},{rootMargin:'100px'}):null;
  function state(){
    root.dataset.sfMotion=staticMode()||document.hidden?'paused':'running';
    $$('[data-sf-motion-toggle]').forEach(button=>button.remove());
    reveals.forEach(animation=>{if(staticMode()||document.hidden)animation.finish();});
    schedule();
  }
  function initialize(scope=document){
    root.classList.add('has-scroll-fallback');
    $$('.sf-design [data-capsule-scene],.sf-design [data-parallax],.sf-design [data-sf-scene]',scope).forEach(scene=>{if(scenes.has(scene))return;scenes.add(scene);observer?.observe(scene);});
    $$('.sf-design .reveal',scope).forEach(el=>{
      if(bound.has(el))return;bound.add(el);
      if(staticMode()||!('IntersectionObserver' in window)||el.closest('header'))return;
      const ob=new IntersectionObserver(entries=>entries.forEach(entry=>{
        if(!entry.isIntersecting)return;
        if(!staticMode()&&!document.hidden){const animation=el.animate([{opacity:.4,transform:'translateY(16px)'},{opacity:1,transform:'translateY(0)'}],{duration:800,easing:'cubic-bezier(.22,.61,.36,1)'});reveals.add(animation);animation.finished.then(()=>reveals.delete(animation)).catch(()=>reveals.delete(animation));}
        ob.disconnect();
      }),{threshold:.08});ob.observe(el);
    });
    const current=new URL(location.href);
    $$('.section-drawer__list a',scope).forEach(link=>{const dest=new URL(link.getAttribute('href'),document.baseURI);if(dest.pathname===current.pathname&&dest.searchParams.get('view')===current.searchParams.get('view'))link.setAttribute('aria-current','page');});
    state();
  }
  document.addEventListener('click',event=>{
    const target=event.target instanceof Element?event.target:event.target.parentElement;
    const link=target.closest('[data-sf-shop]'),form=$('#purchase-form');
    if(link&&form){event.preventDefault();form.scrollIntoView({behavior:staticMode()?'auto':'smooth',block:'start'});$('input:not(:disabled)',form)?.focus({preventScroll:true});}
  });
  document.addEventListener('shopify:section:load',e=>initialize(e.target));
  document.addEventListener('shopify:section:unload',schedule);
  document.addEventListener('visibilitychange',state);reduced.addEventListener('change',state);
  addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize());else initialize();
})();

;
/* END hsx-runtime-legacy.js: hsx-original.js */
;
/* END SOURCE legacy route bootstrap */
}

/* BEGIN SOURCE assets/hsx-runtime-core.js */
/* HealthspanX Luminous Field runtime build. Source-preserving consolidation; order-sensitive JS. */
/* BEGIN hsx-runtime-core.js: hsx-site.js (1) */
(() => {
  'use strict';
  if (window.hsxSiteLoaded) return;
  window.hsxSiteLoaded = true;
  const $ = (s,r=document) => r.querySelector(s), $$ = (s,r=document) => [...r.querySelectorAll(s)];
  const root = window.Shopify?.routes?.root || '/', config = window.HSXShop || {};
  const keys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','gclid'];
  const ready = new WeakSet(), focusOrigins = new WeakMap();
  let busy = false;
  let cartReadId = 0;
  const offers = {once:{1:{price:6495,save:0},2:{price:12341,save:5},4:{price:23382,save:10},8:{price:45725,save:12}},subscription:{1:{price:5846,save:10,cadence:'approximately monthly'},4:{price:22083,save:15,cadence:'approximately every four months'}}};
  function money(value,currency=config.currency||'USD') { return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency}).format(Number(value)/100); }
  function node(tag,text,cls) { const e=document.createElement(tag);if(text!==undefined)e.textContent=text;if(cls)e.className=cls;return e; }
  function attribution() { const q=new URLSearchParams(location.search);return Object.fromEntries(keys.flatMap(k=>q.get(k)?.trim()?[[k,q.get(k).trim().slice(0,512)]]:[])); }
  function marketingAllowed() { try{return window.Shopify?.customerPrivacy?.marketingAllowed?.()===true;}catch(_){return false;} }
  function preserve(url) { const q=new URLSearchParams(location.search);[...keys,'preview_theme_id'].forEach(k=>{if(q.get(k)&&!url.searchParams.has(k))url.searchParams.set(k,q.get(k).slice(0,512));});return url; }
  function openDialog(id,trigger) { const dialog=document.getElementById(id);if(!dialog||typeof dialog.showModal!=='function')return false;$$('dialog[open]').forEach(d=>d.close());focusOrigins.set(dialog,trigger||document.activeElement);dialog.showModal();document.body.style.overflow='hidden';trigger?.setAttribute('aria-expanded','true');return true; }
  function reveal(hash) { if(!hash||hash==='#')return;let target;try{target=document.getElementById(decodeURIComponent(hash.slice(1)));}catch(_){return;}if(!target)return;if(target.matches('details'))target.open=true;let ancestor=target.closest('details');while(ancestor){ancestor.open=true;ancestor=ancestor.parentElement?.closest('details');} }
  async function jsonRequest(url,payload) {
    const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),20000);
    try{const response=await fetch(url,{method:payload?'POST':'GET',credentials:'same-origin',headers:{Accept:'application/json',...(payload?{'Content-Type':'application/json'}:{})},...(payload?{body:JSON.stringify(payload)}:{}),cache:'no-store',signal:controller.signal});let data;try{data=await response.json();}catch(_){throw new Error('We could not read the cart response. Please try again.');}if(!response.ok)throw new Error(typeof data.description==='string'?data.description:'The cart could not be updated. Please try again.');return data;}finally{clearTimeout(timer);}
  }
  function cartError(message) { $$('[data-hsx-cart-error]').forEach(e=>{e.textContent=message;}); }
  function setBusy(value) { busy=value;$$('[data-hsx-cart-items],[data-hsx-cart-page]').forEach(e=>{e.setAttribute('aria-busy',String(value));$$('button,input',e).forEach(c=>{c.disabled=value;});});$$('#hsx-cart button[name="checkout"]').forEach(e=>{e.disabled=value;}); }
  function cartRow(item,currency) {
    const row=node('article',undefined,'hsx-cart-row');row.dataset.hsxLineKey=item.key;
    const raw=item.featured_image?.url||item.image;
    let image;try{const url=new URL(raw,location.origin);if(raw&&['https:','http:'].includes(url.protocol)){image=node('img');image.src=url.href;image.alt=item.featured_image?.alt||item.product_title||item.title;image.width=76;image.height=95;image.loading='lazy';}}catch(_){}
    row.append(image||node('span','NMN','hsx-badge'));
    const info=node('div'),heading=node('h3'),link=node('a',item.product_title||item.title);link.href=item.url||config.shop||root+'products/nmn500-62';heading.append(link);info.append(heading);
    if(item.variant_title&&item.variant_title!=='Default Title')info.append(node('p',item.variant_title));
    if(item.selling_plan_allocation?.selling_plan?.name)info.append(node('p',item.selling_plan_allocation.selling_plan.name));
    const price=node('p',undefined,'hsx-cart-line-price');if(item.original_line_price>item.final_line_price)price.append(node('s',money(item.original_line_price,currency)),document.createTextNode(' '));price.append(document.createTextNode(money(item.final_line_price,currency)));info.append(price);
    (item.line_level_discount_allocations||[]).forEach(d=>info.append(node('p',d.discount_application?.title||'Discount applied','hsx-small')));
    const quantity=node('div',undefined,'hsx-quantity'),minus=node('button','-'),input=node('input'),plus=node('button','+'),remove=node('button','Remove','hsx-remove');
    minus.type=plus.type=remove.type='button';minus.dataset.hsxCartDelta='-1';plus.dataset.hsxCartDelta='1';remove.dataset.hsxCartRemove='';
    minus.setAttribute('aria-label','Decrease quantity of '+item.product_title);plus.setAttribute('aria-label','Increase quantity of '+item.product_title);remove.setAttribute('aria-label','Remove '+item.product_title);
    input.type='number';input.value=item.quantity;input.min='0';input.max='999';input.step='1';input.dataset.hsxCartQuantity='';input.setAttribute('aria-label','Quantity of '+item.product_title);
    quantity.append(minus,input,plus);info.append(quantity,remove);row.append(info);return row;
  }
  function renderCart(cart) {
    const currency=cart.currency||config.currency||'USD';
    $$('[data-hsx-cart-count]').forEach(e=>{e.textContent=cart.item_count;e.hidden=cart.item_count===0;});
    $$('[data-hsx-cart-items]').forEach(e=>{e.replaceChildren();if(cart.items.length){cart.items.forEach(i=>e.append(cartRow(i,currency)));}else{const empty=node('div',undefined,'hsx-empty'),link=node('a','Explore NMN','hsx-button');link.href=config.shop||root+'products/nmn500-62';empty.append(node('h3','Your cart is empty.'),node('p','Explore Ultra Pure NMN and choose your purchase option.'),link);e.append(empty);}});
    $$('[data-hsx-cart-total]').forEach(e=>{e.textContent=money(cart.total_price,currency);});$$('[data-hsx-cart-summary]').forEach(e=>{e.hidden=cart.item_count===0;});
    document.dispatchEvent(new CustomEvent('hsx:cart-updated',{detail:{itemCount:cart.item_count}}));
  }
  async function refreshCartPage() {
    const current=$('[data-hsx-cart-page]');if(!current)return;
    const url=preserve(new URL(config.cart||root+'cart',location.origin));url.searchParams.set('section_id','hsx-cart-page');
    const response=await fetch(url,{credentials:'same-origin',cache:'no-store'});if(!response.ok)throw new Error('Your cart changed. Reload this page to review the latest totals.');
    const updated=$('[data-hsx-cart-page]',new DOMParser().parseFromString(await response.text(),'text/html'));if(!updated)throw new Error('Your cart changed. Reload this page to review the latest totals.');current.replaceWith(updated);
  }
  async function showCart(trigger) {
    if(!openDialog('hsx-cart',trigger)){location.assign(config.cart||root+'cart');return;}
    const requestId = ++cartReadId;
    const drawer = $('#hsx-cart');
    cartError('');
    $$('[data-hsx-cart-summary]',drawer).forEach(e=>{e.hidden=true;});
    $$('[data-hsx-cart-items]',drawer).forEach(e=>{
      e.setAttribute('aria-busy','true');
      e.replaceChildren(node('p','Loading your cart…'));
    });
    try {
      const cart = await jsonRequest(root+'cart.js');
      if(requestId!==cartReadId)return;
      if(!cart||!Array.isArray(cart.items)||!Number.isInteger(cart.item_count)||!Number.isFinite(cart.total_price))throw new Error('Invalid cart response.');
      renderCart(cart);
    } catch (_) {
      if(requestId===cartReadId) {
        $$('[data-hsx-cart-items]',drawer).forEach(e=>{e.replaceChildren();});
        cartError('Your cart could not be loaded. Please try again or open the full cart.');
      }
    } finally {
      if(requestId===cartReadId)$$('[data-hsx-cart-items]',drawer).forEach(e=>{e.setAttribute('aria-busy','false');});
    }
  }
  async function changeCart(key,quantity,control) {
    if(busy||!key||!Number.isInteger(quantity)||quantity<0||quantity>999)return;
    const container=control?.closest('dialog')||document,delta=control?.dataset.hsxCartDelta;
    setBusy(true);cartError('');
    try{const cart=await jsonRequest(root+'cart/change.js',{id:key,quantity});cartReadId++;renderCart(cart);await refreshCartPage();}
    catch(error){cartError(error.name==='AbortError'?'The request timed out. Refresh your cart before trying again.':error.message);}
    finally{setBusy(false);const row=$$('[data-hsx-line-key]',container).find(e=>e.dataset.hsxLineKey===key);const next=row&&(delta?$$('[data-hsx-cart-delta]',row).find(e=>e.dataset.hsxCartDelta===delta):$('[data-hsx-cart-quantity]',row));if(next)next.focus();else if(control&&!control.isConnected){const fallback=$('[data-hsx-close]',container)||$('#MainContent');fallback?.focus();}}
  }
  function commerce() { try{return JSON.parse($('#hsx-commerce-data')?.textContent||'{}');}catch(_){return {};} }
  function state(form) { return {mode:$('input[name="mode"]:checked',form)?.value||null,pack:Number($('input[name="quantity"]:checked',form)?.value)||null}; }
  function validate(mode,pack,data) {
    const offer=offers[mode]?.[pack];if(!offer)return {ok:false,message:'Choose a purchase type and pack quantity.'};
    const mapping=data.mapping?.[pack],variant=data.variants?.find(v=>String(v.id)===String(mapping?.id));
    if(!mapping?.id||!variant)return {ok:false,message:'This pack option is not available at checkout yet.'};
    if(!variant.available)return {ok:false,message:'This option is currently unavailable.'};
    if(data.currency!=='USD')return {ok:false,message:'This USD offer is not available in the selected checkout currency.'};
    const quantity=Number(mapping.quantity)||1;let amount=Number(variant.price)*quantity,plan;
    if(mode==='subscription'){plan=data.plans?.[pack];const allocation=variant.allocations?.find(a=>String(a.id)===String(plan));if(!plan||!allocation?.recurring)return {ok:false,message:'This subscription option is not available at checkout yet.'};amount=Number(allocation.price)*quantity;}
    if(amount!==offer.price)return {ok:false,message:'This offer is not available at the displayed price yet. Please contact support for help.'};
    return {ok:true,id:variant.id,quantity,plan,offer};
  }
  function updatePurchase(form) {
    let {mode,pack}=state(form);
    $$('[data-once-only]',form).forEach(label=>{const input=$('input',label);label.hidden=mode==='subscription';input.disabled=label.hidden;if(input.disabled&&input.checked){input.checked=false;pack=null;}});
    $$('#quantities .choice',form).forEach(label=>{const count=Number($('input',label).value),offer=offers[mode]?.[count],price=$('[data-card-price]',label),saving=$('[data-card-savings]',label),cadence=$('[data-card-cadence]',label);price.hidden=!offer;price.textContent=offer?money(offer.price,'USD')+(mode==='subscription'?' / shipment':' total'):'';saving.hidden=!offer?.save;saving.textContent=offer?.save?'Save '+offer.save+'%':'';cadence.hidden=!(offer&&mode==='subscription');cadence.textContent=offer?.cadence||'';});
    const offer=offers[mode]?.[pack],match=validate(mode,pack,commerce());
    $('#fit-note',form).hidden=pack!==4;$('#eight-pack-note',form).hidden=!(mode==='once'&&pack===8);
    $('#quantity-note',form).textContent=mode?'Savings vs buying the same quantity as one-time 1-packs at $64.95 each. Supply days use two capsules daily.':'Choose how to buy to see prices. Supply days use the label\u2019s two capsules daily.';
    $('#price',form).textContent=offer?money(offer.price,'USD'):mode==='subscription'?'From $58.46':'From $64.95';
    $('#price-unit',form).textContent=offer?(mode==='subscription'?'USD / shipment':'USD / order'):(mode==='subscription'?'USD \u00b7 1 pack / shipment':'USD \u00b7 1 pack, one-time');
    $('#price-detail',form).textContent=offer?pack+' '+(pack===1?'pack':'packs')+' \u00b7 '+money(offer.price/pack,'USD')+' per pack':'Select purchase type and quantity to see your total.';
    const recurrence=$('#recurrence',form);recurrence.hidden=!(offer&&mode==='subscription');recurrence.textContent=offer&&mode==='subscription'?money(offer.price,'USD')+' charged per recurring shipment, '+offer.cadence+'. Shipping and applicable taxes are determined at checkout.':'';
    const button=$('#purchase-button',form);button.disabled=!match.ok||busy;button.textContent=offer?(mode==='subscription'?'Subscribe \u2014 '+money(offer.price,'USD')+' / shipment':'Add to cart \u2014 '+money(offer.price,'USD')):'Choose your purchase options';
    const status=$('#purchase-status',form);if(status)status.textContent=offer&&!match.ok?match.message:'';
  }
  async function addPurchase(form) {
    if(busy)return;const {mode,pack}=state(form),match=validate(mode,pack,commerce()),status=$('#purchase-status',form),button=$('#purchase-button',form);
    if(!match.ok){status.textContent=match.message;return;}
    busy=true;button.disabled=true;button.textContent='Adding to cart...';form.setAttribute('aria-busy','true');let errorMessage='';
    try{
      if(marketingAllowed()){const attributes=attribution();if(Object.keys(attributes).length){try{await jsonRequest(root+'cart/update.js',{attributes});}catch(_){}}}
      await jsonRequest(root+'cart/add.js',{items:[{id:match.id,quantity:match.quantity,...(match.plan?{selling_plan:match.plan}:{})}]});await showCart(button);
    }catch(error){errorMessage=error.name==='AbortError'?'The request timed out. Check your cart before trying again.':error.message;}
    finally{busy=false;form.removeAttribute('aria-busy');updatePurchase(form);if(errorMessage)status.textContent=errorMessage;}
  }
  function auditDestination(raw) {
    const url=new URL(raw),entries=[...url.searchParams.entries()];
    if(url.protocol!=='https:'||url.origin!=='https://radiantlife.healthspanx.org'||url.pathname.replace(/\/$/,'')!=='/audit'||url.username||url.password||url.hash)throw new Error('Invalid Assessment destination.');
    if(entries.length&&(entries.length!==1||entries[0][0]!=='handoff_token'||!entries[0][1]||entries[0][1].length>2048))throw new Error('Invalid Assessment destination.');return url.href;
  }
  async function startAssessment(form) {
    if(form.dataset.submitting==='true'||!form.reportValidity())return;
    const status=$('[data-hsx-assessment-status]',form),button=$('[type="submit"]',form),controller=new AbortController(),timer=setTimeout(()=>controller.abort(),20000);
    form.dataset.submitting='true';form.setAttribute('aria-busy','true');button.disabled=true;status.textContent='Preparing your Assessment...';let redirecting=false;
    try{const response=await fetch('https://radiantlife.healthspanx.org/api/assessment/start',{method:'POST',mode:'cors',credentials:'include',cache:'no-store',referrerPolicy:'no-referrer',headers:{Accept:'application/json','Content-Type':'application/json'},signal:controller.signal,body:JSON.stringify({email:$('[name="email"]',form).value.trim(),marketing_email_consent:$('[name="marketing_email_consent"]',form).checked,started_at:new Date().toISOString(),attribution:marketingAllowed()?attribution():{}})});
      if(response.status===422)throw new Error('Please check your email address and try again.');if(response.status===429)throw new Error('Too many attempts. Please wait a moment and try again.');if(response.status!==200)throw new Error('The Assessment could not be started. Please try again later.');
      const data=await response.json();if(data.status!=='ok'||typeof data.audit_url!=='string')throw new Error('The Assessment session was not confirmed. Please try again.');const destination=auditDestination(data.audit_url);redirecting=true;status.textContent='Opening your Assessment...';location.assign(destination);
    }catch(error){status.textContent=/^(Please check|Too many|The Assessment)/.test(error.message)?error.message:'We could not start the Assessment right now. Please try again or contact support.';}
    finally{clearTimeout(timer);if(!redirecting){delete form.dataset.submitting;form.removeAttribute('aria-busy');button.disabled=false;}}
  }
  function setupEvidence(scope) {
    if(ready.has(scope))return;ready.add(scope);
    const rows=$$('[data-hsx-record]',scope),list=$('[data-hsx-records]',scope),search=$('[data-hsx-evidence-search]',scope),kind=$('[data-hsx-evidence-kind]',scope),domain=$('[data-hsx-evidence-domain]',scope),sort=$('[data-hsx-evidence-sort]',scope);
    const more=$('[data-hsx-evidence-more]',scope),load=$('[data-hsx-evidence-load]',scope),media=matchMedia('(max-width:800px)'),abort=new AbortController();
    let limit=12,matching=[];
    [...new Set(rows.map(r=>r.dataset.domain).filter(Boolean))].sort().forEach(value=>{const option=node('option',value);option.value=value;domain.append(option);});
    function update(keepLimit=false){
      if(!keepLimit)limit=12;
      const term=search.value.trim().toLocaleLowerCase();
      const sorted=[...rows].sort((a,b)=>sort.value==='oldest'?Number(a.dataset.year)-Number(b.dataset.year):sort.value==='title'?a.dataset.title.localeCompare(b.dataset.title):Number(b.dataset.year)-Number(a.dataset.year));
      sorted.forEach(row=>list.append(row));
      matching=sorted.filter(row=>(!term||row.dataset.search.toLocaleLowerCase().includes(term))&&(kind.value==='all'||row.dataset.kind===kind.value)&&(domain.value==='all'||row.dataset.domain===domain.value));
      const available=media.matches&&load?limit:matching.length;
      const shown=new Set(matching.slice(0,available));
      rows.forEach(row=>{row.hidden=!shown.has(row);});
      const status=$('[data-hsx-evidence-count]',scope);
      status.textContent=media.matches&&more?more.dataset.progress.replace('[shown]',String(shown.size)).replace('[total]',String(matching.length)):matching.length+' of '+rows.length+(scope.dataset.hsxHasMore==='true'?' records on this page':' published records');
      $('[data-hsx-evidence-empty]',scope).hidden=matching.length>0;
      const filterCount=$('[data-hsxm-filter-count]',scope);if(filterCount){const active=Number(kind.value!=='all')+Number(domain.value!=='all')+Number(sort.value!=='newest');filterCount.textContent=String(active);filterCount.hidden=active===0;}
      if(more)more.hidden=!media.matches||shown.size>=matching.length;
    }
    search.addEventListener('input',()=>update(),{signal:abort.signal});
    [kind,domain,sort].forEach(e=>e.addEventListener('change',()=>update(),{signal:abort.signal}));
    $$('[data-hsx-evidence-reset]',scope).forEach(button=>button.addEventListener('click',()=>{search.value='';kind.value=domain.value='all';sort.value='newest';update();search.focus();},{signal:abort.signal}));
    load?.addEventListener('click',()=>{const next=matching[limit];limit+=12;update(true);next?.querySelector('h2 a')?.focus();},{signal:abort.signal});
    media.addEventListener('change',()=>update(),{signal:abort.signal});
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(scope))abort.abort();},{signal:abort.signal});
    update();
  }
  function initialize(scope=document) {
    $$('#purchase-form',scope).forEach(form=>{if(!ready.has(form)){ready.add(form);updatePurchase(form);}});$$('[data-hsx-evidence]',scope).forEach(setupEvidence);
    $$('dialog',scope).forEach(dialog=>{if(ready.has(dialog))return;ready.add(dialog);dialog.addEventListener('close',()=>{if(!$('dialog[open]'))document.body.style.overflow='';$$('[aria-controls="'+dialog.id+'"]').forEach(e=>e.setAttribute('aria-expanded','false'));const origin=focusOrigins.get(dialog);if(origin?.isConnected&&!$('dialog[open]'))origin.focus();});dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();});});
    $$('.hsx-logo img',scope).forEach(image=>{const fallback=()=>{const logo=image.closest('.hsx-logo');if(!logo||logo.dataset.fallback)return;logo.dataset.fallback='true';$$('img',logo).forEach(i=>i.remove());logo.append(node('span','HealthspanX','hsx-wordmark'));};image.addEventListener('error',fallback);if(image.complete&&!image.naturalWidth)fallback();});
    $$('[data-hsx-theme]',scope).forEach(e=>e.setAttribute('aria-pressed',String(document.documentElement.dataset.theme==='dark')));reveal(location.hash);
  }
  document.addEventListener('click',event=>{
    const target=event.target instanceof Element?event.target:event.target.parentElement;
    const theme=target.closest('[data-hsx-theme]');if(theme){const mode=document.documentElement.dataset.theme==='dark'?'light':'dark';document.documentElement.dataset.theme=mode;try{localStorage.setItem('hsx-theme',mode);}catch(_){}$$('[data-hsx-theme]').forEach(e=>e.setAttribute('aria-pressed',String(mode==='dark')));return;}
    const close=target.closest('[data-hsx-close]');if(close){close.closest('dialog')?.close();return;}
    const menu=target.closest('[data-hsx-menu]');if(menu){openDialog('hsx-menu',menu);return;}
    const cart=target.closest('[data-hsx-cart-open]');if(cart){event.preventDefault();showCart(cart);return;}
    const assessment=target.closest('[data-hsx-assessment-open],[data-preview="assessment"]');if(assessment){event.preventDefault();openDialog('hsx-assessment',assessment);return;}
    const delta=target.closest('[data-hsx-cart-delta]'),remove=target.closest('[data-hsx-cart-remove]');if(delta||remove){event.preventDefault();const control=delta||remove,row=control.closest('[data-hsx-line-key]');if(!row)return;changeCart(row.dataset.hsxLineKey,remove?0:Number($('[data-hsx-cart-quantity]',row).value)+Number(delta.dataset.hsxCartDelta),control);return;}
    $$('.hsx-nav details[open]').forEach(e=>{if(!e.contains(target))e.open=false;});
    const link=target.closest('a[href]');if(link&&!link.hasAttribute('download')){const href=link.getAttribute('href');if(href.startsWith('#')){reveal(href);return;}try{const url=new URL(href,location.origin);if(url.origin===location.origin&&!url.pathname.startsWith('/checkout'))link.href=preserve(url).href;}catch(_){}}
  });
  document.addEventListener('change',event=>{const target=event.target,form=target.closest('#purchase-form');if(form)updatePurchase(form);if(target.matches('[data-hsx-cart-quantity]')){if(!target.checkValidity()){target.reportValidity();return;}changeCart(target.closest('[data-hsx-line-key]').dataset.hsxLineKey,Number(target.value),target);}});
  document.addEventListener('submit',event=>{const form=event.target;if(form.matches('#purchase-form')){event.preventDefault();addPurchase(form);}if(form.matches('#hsx-assessment-form')){event.preventDefault();startAssessment(form);}if(form.matches('[data-hsx-cart-form]')&&busy)event.preventDefault();});
  document.addEventListener('keydown',event=>{if(event.key==='Escape')$$('.hsx-nav details[open]').forEach(e=>{e.open=false;$('summary',e).focus();});});
  window.addEventListener('hashchange',()=>reveal(location.hash));document.addEventListener('shopify:section:load',event=>initialize(event.target));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize());else initialize();
})();

;
/* END hsx-runtime-core.js: hsx-site.js */
/* BEGIN hsx-runtime-core.js: hx-premium.js (2) */
(() => {
  'use strict';
  if (window.hxLuminousReady) return;
  window.hxLuminousReady = true;
  const root = document.documentElement;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialized = new WeakMap();
  const videos = new Map();
  const scenes = new Map();
  const animations = new Set();
  const seen = new WeakSet();
  let frame = 0;
  const store = {
    get(key) { try { return localStorage.getItem(key); } catch (_) { return null; } },
    set(key, value) { try { localStorage.setItem(key, value); } catch (_) {} }
  };
  const paused = () => reduced.matches || root.dataset.motion === 'paused';
  function collect(scope, selector) {
    return [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)];
  }
  function controls() {
    const dark = root.dataset.theme === 'dark';
    document.querySelectorAll('[data-hx-dock]').forEach(dock => { dock.hidden = false; });
    document.querySelectorAll('[data-hx-theme-toggle]').forEach(button => {
      button.hidden = false;
      button.setAttribute('aria-pressed', String(dark));
      button.setAttribute('aria-label', dark ? button.dataset.lightLabel : button.dataset.darkLabel);
    });

  }
  function updateScene() {
    frame = 0;
    scenes.forEach((active, scene) => {
      if (!scene.isConnected) { scenes.delete(scene); return; }
      if (paused() || window.innerWidth <= 800) {
        scene.style.setProperty('--hx-progress', '1');
        return;
      }
      if (!active) return;
      const rect = scene.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, (innerHeight * .84 - rect.top) / Math.max(1, rect.height * .64)));
      scene.style.setProperty('--hx-progress', progress.toFixed(3));
    });
  }
  function scheduleScene() { if (!frame) frame = requestAnimationFrame(updateScene); }
  function playVisual(node) {
    if (paused() || document.hidden || !node.animate || seen.has(node)) return;
    seen.add(node);
    const animation = node.animate([{ transform: 'translateY(14px)' }, { transform: 'translateY(0)' }], { duration: 760, easing: 'cubic-bezier(.22,.61,.36,1)' });
    animations.add(animation);
    animation.finished.catch(() => {}).finally(() => animations.delete(animation));
  }
  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      playVisual(entry.target);
      revealObserver.unobserve(entry.target);
    });
  }, { threshold: .12 }) : null;
  const sceneObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { scenes.set(entry.target, entry.isIntersecting); });
    scheduleScene();
  }, { rootMargin: '80px' }) : null;
  const videoObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = videos.get(entry.target);
      if (!state) return;
      state.visible = entry.isIntersecting;
      if (paused() || document.hidden || !state.visible) entry.target.pause();
      else if (!state.userPaused && state.auto) entry.target.play().catch(() => {});
    });
  }, { threshold: .25 }) : null;
  function applyMotion() {
    if (paused()) {
      animations.forEach(animation => animation.cancel());
      animations.clear();
      videos.forEach((_, video) => video.pause());
    } else {
      videos.forEach((state, video) => {
        if (state.auto && state.visible && !state.userPaused && !document.hidden) video.play().catch(() => {});
      });
    }
    controls();
    scheduleScene();
  }
  function init(scope = document) {
    collect(scope, '[data-hx-mobile]').forEach(menu => {
      if (initialized.has(menu)) return;
      const abort = new AbortController();
      initialized.set(menu, abort);
      const opts = { signal: abort.signal };
      menu.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        menu.open = false;
        menu.querySelector('summary')?.focus();
      }, opts);
      menu.addEventListener('click', event => {
        if (event.target.closest('a[href]')) menu.open = false;
      }, opts);
      const summary = menu.querySelector('summary');
      const updateMenu = () => {
        document.querySelectorAll('[data-hx-menu-launch]').forEach(button => button.setAttribute('aria-expanded', String(menu.open)));
        if (summary) summary.setAttribute('aria-label', menu.open ? 'Close navigation menu' : 'Open navigation menu');
      };
      menu.addEventListener('toggle', updateMenu, opts);
      updateMenu();
    });
    collect(scope, '[data-hx-video]').forEach(wrap => {
      const video = wrap.querySelector('video');
      if (!video || videos.has(video)) return;
      const abort = new AbortController();
      const state = { auto: wrap.dataset.autoplay === 'true', visible: false, userPaused: false, abort };
      videos.set(video, state);
      video.muted = true;
      video.addEventListener('pointerdown', () => { state.userPaused = true; }, { signal: abort.signal });
      video.addEventListener('keydown', () => { state.userPaused = true; }, { signal: abort.signal });
      videoObserver?.observe(video);
      if (paused()) video.pause();
    });
    collect(scope, '[data-hx-cell]').forEach(scene => {
      if (scenes.has(scene)) return;
      scenes.set(scene, true);
      sceneObserver?.observe(scene);
    });
    collect(scope, '.hx-card, .hx-step, .hx-intro, .hx-hero__copy, .hx-cta').forEach(node => {
      if (!seen.has(node)) revealObserver?.observe(node);
    });
    collect(scope, '[data-hx-gallery]').forEach(gallery => {
      if (initialized.has(gallery)) return;
      const abort = new AbortController();
      initialized.set(gallery, abort);
      const tablist = gallery.querySelector('[data-hx-gallery-tabs]');
      if (tablist) tablist.hidden = false;
      const tabs = [...gallery.querySelectorAll('[data-hx-gallery-target]')];
      const panels = [...gallery.querySelectorAll('[data-hx-gallery-panel]')];
      function activate(button) {
        tabs.forEach(tab => {
          const active = tab === button;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        panels.forEach(panel => { panel.hidden = panel.id !== button.dataset.hxGalleryTarget; });
      }
      tabs.forEach(button => {
        button.addEventListener('click', () => activate(button), { signal: abort.signal });
        button.addEventListener('keydown', event => {
          const index = tabs.indexOf(button);
          const key = event.key;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) return;
          event.preventDefault();
          const next = key === 'Home' ? 0 : key === 'End' ? tabs.length - 1 : (index + (key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          activate(tabs[next]);
          tabs[next].focus();
        }, { signal: abort.signal });
      });
      if (tabs.length) activate(tabs[0]);
    });
    controls();
    scheduleScene();
  }
  function cleanup(scope) {
    collect(scope, '[data-hx-mobile], [data-hx-gallery]').forEach(node => {
      initialized.get(node)?.abort();
      initialized.delete(node);
    });
    collect(scope, '[data-hx-cell]').forEach(scene => { sceneObserver?.unobserve(scene); scenes.delete(scene); });
    collect(scope, '.hx-card, .hx-step, .hx-intro, .hx-hero__copy, .hx-cta').forEach(node => revealObserver?.unobserve(node));
    collect(scope, 'video').forEach(video => {
      video.pause();
      videos.get(video)?.abort.abort();
      videoObserver?.unobserve(video);
      videos.delete(video);
    });
  }
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    if (!target) return;
    const theme = target.closest('[data-hx-theme-toggle]');
    if (theme) {
      root.dataset.theme = root.dataset.theme === 'dark' ? 'light' : 'dark';
      store.set('hsx-theme', root.dataset.theme);
      controls();
    }
    const launch = target.closest('[data-hx-menu-launch]');
    if (launch) {
      const menu = document.querySelector('[data-hx-mobile]');
      if (menu) { menu.open = !menu.open; menu.querySelector('summary')?.focus(); }
      return;
    }
    document.querySelectorAll('[data-hx-mobile][open]').forEach(menu => {
      if (!menu.contains(target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-hx-mobile][open]').forEach(menu => { menu.open = false; menu.querySelector('summary')?.focus(); });
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => cleanup(event.target));
  document.addEventListener('shopify:block:select', event => {
    const details = event.target.closest('details');
    if (details) details.open = true;
  });
  document.addEventListener('visibilitychange', () => {
    root.dataset.pageHidden = String(document.hidden);
    if (document.hidden) videos.forEach((_, video) => video.pause());
    else applyMotion();
  });
  reduced.addEventListener('change', applyMotion);
  window.addEventListener('scroll', scheduleScene, { passive: true });
  window.addEventListener('resize', scheduleScene, { passive: true });
  window.addEventListener('storage', event => {
    if (event.key === 'hsx-theme' && ['light','dark'].includes(event.newValue)) root.dataset.theme = event.newValue;
    applyMotion();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();

;
/* END hsx-runtime-core.js: hx-premium.js */
;
/* END SOURCE assets/hsx-runtime-core.js */

/* BEGIN SOURCE assets/hx-journal.js */
(function(){'use strict';function setup(root){root.querySelectorAll('[data-hx-journal]').forEach(function(scope){if(scope.dataset.initialized)return;scope.dataset.initialized='true';var list=scope.querySelector('[data-hx-journal-list]'),rows=Array.from(scope.querySelectorAll('[data-hx-journal-card]')),input=scope.querySelector('[data-hx-journal-search]'),status=scope.querySelector('[data-hx-journal-count]'),pagination=scope.querySelector('[data-hx-journal-pagination]'),prev=scope.querySelector('[data-hx-journal-prev]'),next=scope.querySelector('[data-hx-journal-next]'),pageLabel=scope.querySelector('[data-hx-journal-page]'),empty=scope.querySelector('[data-hx-journal-empty]'),page=1,size=12;rows.sort(function(a,b){return Number(b.dataset.date)-Number(a.dataset.date);}).forEach(function(row){list.appendChild(row);});function update(){var term=input.value.trim().toLocaleLowerCase(),matches=rows.filter(function(row){return !term||(row.dataset.search||row.dataset.title||'').toLocaleLowerCase().includes(term);}),pages=Math.max(1,Math.ceil(matches.length/size));page=Math.min(page,pages);rows.forEach(function(row){row.hidden=true;});matches.slice((page-1)*size,page*size).forEach(function(row){row.hidden=false;});status.textContent=matches.length+' articles'+(term?' matching your search':' in this journal view');pagination.hidden=matches.length<=size;prev.disabled=page===1;next.disabled=page===pages;pageLabel.textContent='Page '+page+' of '+pages;empty.hidden=matches.length>0;}input.addEventListener('input',function(){page=1;update();});prev.addEventListener('click',function(){if(page>1){page--;update();status.scrollIntoView({block:'center'});}});next.addEventListener('click',function(){page++;update();status.scrollIntoView({block:'center'});});update();});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){setup(document);});else setup(document);document.addEventListener('shopify:section:load',function(e){setup(e.target);});}());

;
/* END SOURCE assets/hx-journal.js */

/* homepage interactions | document.body && document.body.classList.contains('hx-homepage') */
if (document.body && document.body.classList.contains('hx-homepage')) {
/* BEGIN SOURCE homepage interactions */
/* HealthspanX Luminous Field runtime build. Source-preserving consolidation; order-sensitive JS. */
/* BEGIN hsx-runtime-home.js: hx-home-editorial.js (1) */
(() => {
  'use strict';
  if (window.HSXEditorialHome) { window.HSXEditorialHome.refresh(); return; }
  const root = document.documentElement;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const narrow = matchMedia('(max-width: 800px)');
  const sections = new Set();
  const effects = new Set();
  let frame = 0;
  const active = () => !reduced.matches && root.dataset.motion !== 'paused' && !document.hidden;
  const observe = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { entry.target.dataset.hxEditorialActive = String(entry.isIntersecting); });
    schedule();
  }, { rootMargin:'60px', threshold:0 }) : null;
  function update() {
    frame = 0;
    const running = active() && !narrow.matches;
    sections.forEach(section => {
      if (!section.isConnected) { observe?.unobserve(section); sections.delete(section); return; }
      if (!section.querySelector('.hx-home-tools__portrait')) return;
      if (!running) { section.style.setProperty('--hx-editorial-shift','0px'); return; }
      if (section.dataset.hxEditorialActive !== 'true') return;
      const rect = section.getBoundingClientRect();
      const progress = Math.max(-1,Math.min(1, (innerHeight*.5 - rect.top - rect.height*.5) / Math.max(innerHeight,rect.height)));
      section.style.setProperty('--hx-editorial-shift',`${(progress*23).toFixed(2)}px`);
    });
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(update); }
  function sync() {
    root.dataset.hxEditorialMotion = active() ? 'full' : 'paused';
    if (!active()) { effects.forEach(effect=>effect.cancel()); effects.clear(); }
    schedule();
  }
  function init(scope=document) {
    const nodes = [...(scope.matches?.('[data-hx-editorial]') ? [scope] : []),...scope.querySelectorAll('[data-hx-editorial]')];
    nodes.forEach(node=>{
      if(sections.has(node))return;
      sections.add(node);node.dataset.hxEditorialActive='true';observe?.observe(node);
    });
    sync();
  }
  document.addEventListener('toggle',event=>{
    const details=event.target;
    if(!(details instanceof HTMLDetailsElement)||!details.open||!active()||!details.closest('[data-hx-editorial]'))return;
    const target=details.querySelector('.hx-rich,.hx-home-coverage__grid');
    if(!target?.animate)return;
    const effect=target.animate([{opacity:.5,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:380,easing:'cubic-bezier(.22,.61,.36,1)'});
    effects.add(effect);effect.finished.catch(()=>{}).finally(()=>effects.delete(effect));
  },true);
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    for(const section of sections)if(event.target===section||event.target.contains(section)){
      observe?.unobserve(section);sections.delete(section);
    }
  });
  document.addEventListener('shopify:section:reorder',schedule);
  document.addEventListener('shopify:section:select',event=>{
    const section=event.target.querySelector('[data-hx-editorial]');
    if(section)section.dataset.hxEditorialActive='false';
  });
  document.addEventListener('shopify:section:deselect',event=>{
    const section=event.target.querySelector('[data-hx-editorial]');
    if(section)section.dataset.hxEditorialActive='true';
  });
  new MutationObserver(sync).observe(root,{attributes:true,attributeFilter:['data-motion']});
  reduced.addEventListener('change',sync);narrow.addEventListener('change',sync);
  document.addEventListener('visibilitychange',sync);
  addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});
  window.HSXEditorialHome={version:'2026-10-07.1',refresh:()=>init(),status:()=>({sections:sections.size,mode:root.dataset.hxEditorialMotion})};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
})();

;
/* END hsx-runtime-home.js: hx-home-editorial.js */
/* BEGIN hsx-runtime-home.js: hx-cinematic.js (2) */
(() => {
  'use strict';
  if (window.HSXCinematicHero) { window.HSXCinematicHero.refresh(); return; }
  const states = new Map();
  let frame = 0;
  const onScroll = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      document.querySelector('.hx-header')?.classList.toggle('is-scrolled', scrollY > 64);
      frame = 0;
    });
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { entry.target.dataset.inView = String(entry.isIntersecting); });
  }, {threshold:0}) : null;
  function init(scope = document) {
    const elements = [...(scope.matches?.('[data-hx-cinema]') ? [scope] : []), ...scope.querySelectorAll('[data-hx-cinema]')];
    elements.forEach(hero => {
      if (states.has(hero)) return;
      const abort = new AbortController();
      states.set(hero, abort);
      hero.dataset.inView = 'true';
      hero.classList.add('is-motion-ready');
      observer?.observe(hero);
      const video = hero.querySelector('video');
      if (video) {
        video.addEventListener('playing', () => video.parentElement.classList.add('has-playing-video'), {signal:abort.signal});
        video.addEventListener('error', () => video.parentElement.classList.remove('has-playing-video'), {signal:abort.signal});
      }
    });
    onScroll();
  }
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    for (const [node,abort] of states) if(event.target===node || event.target.contains(node)) {
      abort.abort();observer?.unobserve(node);states.delete(node);
    }
  });
  addEventListener('scroll',onScroll,{passive:true});
  document.addEventListener('visibilitychange',()=>{document.documentElement.dataset.pageHidden=String(document.hidden);});
  window.HSXCinematicHero={version:'2026-10-07',refresh:()=>init()};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
})();

;
/* END hsx-runtime-home.js: hx-cinematic.js */
/* BEGIN hsx-runtime-home.js: hx-home.js (3) */
/* HealthspanX homepage motion. No commerce, analytics, consent or enrollment writes. */
(() => {
  'use strict';
  if (window.HSXHomeMotion) { window.HSXHomeMotion.refresh(); return; }
  const root = document.documentElement;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const sections = new Map();
  const scenes = new Map();
  const counts = new Map();
  const canAnimate = typeof Element.prototype.animate === 'function';
  const ease = 'cubic-bezier(.22,.61,.36,1)';
  const paused = () => reduced.matches || root.dataset.motion === 'paused';
  const running = () => !paused() && !document.hidden;
  const find = (scope, selector) => [
    ...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)
  ];
  const animate = (node, frames, options) => {
    if (!node || !canAnimate) return null;
    return node.animate(frames, { duration: 900, easing: ease, ...options });
  };
  function loop(state, node, frames, options) {
    if (!node || !canAnimate) return;
    const animation = animate(node, frames, { iterations: Infinity, easing: 'ease-in-out', ...options });
    animation.pause();
    state.loops.push(animation);
  }
  function reveal(state) {
    if (state.revealed || !state.visible || !running() || !canAnimate) return;
    state.revealed = true;
    const hero = state.node.matches('.hx-home-hero');
    const nodes = hero
      ? [...state.node.querySelectorAll('.hx-home-hero__copy > :not(.hx-home-motion-control)')]
      : [...state.node.querySelectorAll('.hx-home-intro, .hx-home-feature__copy, .hx-home-feature__points article, .hx-home-evidence__panel, .hx-home-tool, .hx-home-journal__card, .hx-faq details, .hx-home-close__field > div, .hx-home-press__names a')];
    nodes.forEach((node, i) => {
      const animation = animate(node,
        hero ? [{transform:'translateY(24px)'},{transform:'translateY(0)'}]
             : [{opacity:.35,transform:'translateY(30px)'},{opacity:1,transform:'translateY(0)'}],
        { duration: hero ? 1050 : 850, delay: Math.min(i * 100, 500), fill:'backwards' });
      if (animation) state.reveals.push(animation);
    });
  }
  function playScene(state, replay = false) {
    if (!canAnimate || !running() || !state.visible || (state.started && !replay)) return;
    state.animations.forEach(a => a.cancel());
    state.animations = [];
    state.started = true;
    const add = (selector, frames) => {
      const a = animate(state.node.querySelector(selector), frames, {duration:6500, fill:'both', easing:'linear'});
      if (a) state.animations.push(a);
    };
    add('.hx-home-capsule__cell', [
      {opacity:1,transform:'scale(.92) rotate(-8deg)',offset:0},
      {opacity:1,transform:'scale(1.02) rotate(0deg)',offset:.22},
      {opacity:.15,transform:'scale(1.12) rotate(10deg)',offset:.5},
      {opacity:.15,transform:'scale(1.12) rotate(10deg)',offset:1}
    ]);
    add('.hx-home-capsule__assembly', [
      {opacity:0,transform:'rotate(-8deg) scale(.8)',offset:0},
      {opacity:0,transform:'rotate(-8deg) scale(.8)',offset:.2},
      {opacity:1,transform:'rotate(22deg) scale(1)',offset:.45},
      {opacity:1,transform:'rotate(22deg) scale(1)',offset:1}
    ]);
    add('.hx-home-capsule__lid', [
      {transform:'translate(0,0) rotate(0deg)',offset:0},
      {transform:'translate(0,0) rotate(0deg)',offset:.44},
      {transform:'translate(-18%,-8%) rotate(-12deg)',offset:.78},
      {transform:'translate(-18%,-8%) rotate(-12deg)',offset:1}
    ]);
    state.node.querySelectorAll('.hx-home-capsule__lines path').forEach((node, index) => {
      const a = animate(node,[{strokeDashoffset:1,opacity:0,offset:0},
        {strokeDashoffset:1,opacity:0,offset:.62 + index*.04},
        {strokeDashoffset:0,opacity:1,offset:.92},
        {strokeDashoffset:0,opacity:1,offset:1}],{duration:6500,fill:'both',easing:'linear'});
      if (a) state.animations.push(a);
    });
  }
  function finishCount(state) {
    cancelAnimationFrame(state.frame);
    state.frame = 0;
    state.node.textContent = String(state.target);
  }
  function startCount(state) {
    if (state.started || !running() || !state.visible) return;
    state.started = true;
    const start = performance.now();
    const tick = now => {
      if (!running() || !state.node.isConnected) { finishCount(state); return; }
      const p = Math.min(1,(now-start)/1700);
      state.node.textContent = String(Math.round(state.target*(1-Math.pow(1-p,3))));
      if (p < 1) state.frame = requestAnimationFrame(tick); else finishCount(state);
    };
    state.frame = requestAnimationFrame(tick);
  }
  function sync() {
    root.dataset.hxHomeMotion = reduced.matches ? 'reduced' : paused() ? 'paused' : 'full';
    sections.forEach(state => {
      state.loops.forEach(a => {
        if (reduced.matches) a.cancel();
        else if (running() && state.visible) a.play();
        else a.pause();
      });
      if (paused()) state.reveals.forEach(a => a.cancel());
      else if (document.hidden) state.reveals.forEach(a => { if(a.playState === 'running') a.pause(); });
      else {
        state.reveals.forEach(a => { if(a.playState === 'paused') a.play(); });
        reveal(state);
      }
    });
    scenes.forEach(state => {
      const button = state.node.querySelector('[data-hx-capsule-replay]');
      if (button) { button.hidden = !canAnimate; button.disabled = paused(); }
      if (reduced.matches) {
        state.animations.forEach(a => a.cancel());
        state.started = false;
      } else if (!running() || !state.visible) {
        state.animations.forEach(a => { if(a.playState === 'running') a.pause(); });
      } else {
        playScene(state);
        state.animations.forEach(a => { if(a.playState === 'paused') a.play(); });
      }
    });
    counts.forEach(state => { if(paused()) finishCount(state); else startCount(state); });
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = sections.get(entry.target) || scenes.get(entry.target) || counts.get(entry.target);
      if (state) state.visible = entry.isIntersecting;
    });
    sync();
  },{threshold:0.12}) : null;
  function init(scope = document) {
    find(scope,'.hx-home').forEach(node => {
      if (sections.has(node)) return;
      const state = {node,visible:!observer,loops:[],reveals:[],revealed:false};
      sections.set(node,state);
      loop(state,node.querySelector('.hx-home-hero__media > img'),[
        {transform:'scale(1.025) translateX(-.5%)'},{transform:'scale(1.09) translateX(.5%)'}
      ],{duration:10000,direction:'alternate'});
      loop(state,node.querySelector('.hx-home-product-art > img'),[
        {transform:'translateY(4px) rotate(-1deg)'},{transform:'translateY(-14px) rotate(1deg)'},{transform:'translateY(4px) rotate(-1deg)'}
      ],{duration:6500});
      loop(state,node.querySelector('.hx-home-close__field > img'),[
        {transform:'rotate(7deg) translateY(5px)'},{transform:'rotate(9deg) translateY(-13px)'},{transform:'rotate(7deg) translateY(5px)'}
      ],{duration:6500});
      loop(state,node.querySelector('.hx-home-evidence__pouch'),[
        {transform:'rotate(7deg) translateY(3px)'},{transform:'rotate(10deg) translateY(-9px)'},{transform:'rotate(7deg) translateY(3px)'}
      ],{duration:7000});
      loop(state,node.querySelector('.hx-home-lens'),[
        {transform:'scale(.86)',opacity:.6},{transform:'scale(1.12)',opacity:1},{transform:'scale(.86)',opacity:.6}
      ],{duration:4200});
      node.querySelectorAll('.hx-home-milestone').forEach((n,i)=>loop(state,n,[
        {transform:'scale(1)',opacity:.65},{transform:'scale(1.1)',opacity:1},{transform:'scale(1)',opacity:.65}
      ],{duration:3600,delay:i*500}));
      observer?.observe(node);
    });
    find(scope,'[data-hx-home-capsule]').forEach(node => {
      if (scenes.has(node)) return;
      const state = {node,visible:!observer,started:false,animations:[]};
      scenes.set(node,state);
      const section = sections.get(node.closest('.hx-home'));
      if (section) loop(section,node.querySelector('.hx-home-capsule__orbit'),[
        {transform:'rotate(0deg)'},{transform:'rotate(360deg)'}
      ],{duration:30000,easing:'linear'});
      observer?.observe(node);
    });
    find(scope,'[data-hx-home-count]').forEach(node => {
      if(counts.has(node)) return;
      const target = Number(node.dataset.hxHomeCount);
      if(!Number.isFinite(target)) return;
      const state = {node,target,visible:!observer,started:false,frame:0};
      counts.set(node,state); observer?.observe(node);
    });
    sync();
  }
  function cleanup(scope) {
    for(const [node,state] of sections) if(scope === node || scope.contains(node)) {
      [...state.loops,...state.reveals].forEach(a=>a.cancel());observer?.unobserve(node);sections.delete(node);
    }
    for(const [node,state] of scenes) if(scope === node || scope.contains(node)) {
      state.animations.forEach(a=>a.cancel());observer?.unobserve(node);scenes.delete(node);
    }
    for(const [node,state] of counts) if(scope === node || scope.contains(node)) {
      finishCount(state);observer?.unobserve(node);counts.delete(node);
    }
  }
  document.addEventListener('click',event => {
    const target = event.target instanceof Element ? event.target : null;
    const replay = target?.closest('[data-hx-capsule-replay]');
    if(replay) { const state=scenes.get(replay.closest('[data-hx-home-capsule]'));if(state)playScene(state,true); }
    const link = target?.closest('.hx-home-press__names a[href^="#"]');
    if(link) { const disclosure=document.getElementById(link.hash.slice(1))?.closest('details');if(disclosure)disclosure.open=true; }
  });
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>cleanup(event.target));
  document.addEventListener('shopify:block:select',event=>{
    const details = event.target.closest?.('.hx-home-coverage');if(details)details.open=true;
  });
  new MutationObserver(sync).observe(root,{attributes:true,attributeFilter:['data-motion']});
  reduced.addEventListener('change',sync);
  document.addEventListener('visibilitychange',sync);
  window.HSXHomeMotion = {version:'2026-10-07',refresh:()=>init(),status:()=>({sections:sections.size,scenes:scenes.size,mode:root.dataset.hxHomeMotion})};
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init());else init();
})();

;
/* END hsx-runtime-home.js: hx-home.js */
;
/* END SOURCE homepage interactions */
}

/* Classic capsule scene: load only when its markup is present, including Theme Editor injection. */
(function () {
  function bootClassic() {
    /* BEGIN SOURCE assets/hsx-homepage-motion.js */
(() => {
  'use strict';
  if (window.hsxHomeResponsive) return;
  window.hsxHomeResponsive = true;
  const root = document.documentElement;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const ringScreen = matchMedia('(min-width: 1024px) and (hover: hover) and (pointer: fine)');
  const shortScreen = matchMedia('(max-height: 600px)');
  const scenes = new Set();
  const orbits = new Map();
  const revealed = new WeakSet();
  const animations = new Set();
  const clamp = value => Math.max(0, Math.min(1, value));
  let frame = 0;
  let lastTime = 0;
  let localPause = false;
  try { localPause = localStorage.getItem('hsx-motion') === 'paused'; } catch (_) {}
  const paused = () => localPause || root.dataset.sfMotion === 'paused';
  const staticMode = () => reduced.matches || paused();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      const orbit = orbits.get(entry.target);
      if (orbit) orbit.visible = entry.isIntersecting;
      entry.target.dataset.lfVisible = String(entry.isIntersecting);
    }
    schedule();
  }, { rootMargin: '80px' }) : null;

  function connectors(scene) {
    const stage = scene.querySelector('.capsule-scene__sticky');
    const focus = scene.querySelector('.capsule-focus');
    const svg = scene.querySelector('[data-connectors]');
    if (!stage || !focus || !svg) return;
    const box = stage.getBoundingClientRect();
    const focal = focus.getBoundingClientRect();
    if (!box.width || !box.height) return;
    svg.setAttribute('viewBox', `0 0 ${box.width} ${box.height}`);
    const origins = { one: [.50, .50], two: [.65, .57], three: [.35, .70], four: [.65, .78], five: [.5, .89] };
    for (const [key, origin] of Object.entries(origins)) {
      const label = scene.querySelector('.capsule-annotation--' + key);
      const path = svg.querySelector('[data-connector="' + key + '"]');
      const dot = svg.querySelector('[data-origin="' + key + '"]');
      if (!label || !path || !dot) continue;
      const rect = label.getBoundingClientRect();
      const x = focal.left - box.left + focal.width * origin[0];
      const y = focal.top - box.top + focal.height * origin[1];
      let endX;
      let endY;
      if (box.width < 660) {
        endX = rect.left - box.left + rect.width / 2;
        endY = rect.top - box.top > y ? rect.top - box.top - 5 : rect.bottom - box.top + 5;
      } else {
        endX = label.classList.contains('capsule-annotation--left') ? rect.right - box.left + 8 : rect.left - box.left - 8;
        endY = rect.top - box.top + (parseFloat(getComputedStyle(label).lineHeight) || 18) / 2;
      }
      const bendX = x + (endX - x) * .45;
      path.setAttribute('d', `M${x.toFixed(2)} ${y.toFixed(2)}L${bendX.toFixed(2)} ${endY.toFixed(2)}L${endX.toFixed(2)} ${endY.toFixed(2)}`);
      path.style.setProperty('--line-len', String(path.getTotalLength()));
      dot.setAttribute('d', `M${x.toFixed(2)} ${y.toFixed(2)}L${x.toFixed(2)} ${y.toFixed(2)}`);
    }
  }

  function paint(scene, progress) {
    scene.dataset.homeProgress = progress.toFixed(3);
    const travel = clamp((progress - .22) / .36);
    const ease = 1 - Math.pow(1 - travel, 3);
    const opening = clamp((progress - .55) / .19);
    const values = {
      '--scene-x': (-40 + ease * 40) + '%', '--scene-y': (28 - ease * 28) + '%',
      '--scene-scale': .34 + ease * .66, '--scene-rotation': (-12 + ease * 12) + 'deg',
      '--scene-cap-lift': opening * 14 + '%', '--scene-cell-opacity': 1 - ease,
      '--scene-cell-scale': 1 - ease * .28, '--scene-cell-x': -ease * 16 + '%',
      '--scene-cell-y': ease * 4 + '%', '--scene-cell-blur': ease * 1.1 + 'rem',
      '--bg-cell-opacity': .5 - ease * .26, '--scene-disc-opacity': .15 + ease * .7,
      '--scene-disc-scale': .48 + ease * .52, '--scene-bloom-opacity': .3 + ease * .4,
      '--scene-bloom-scale': .72 + ease * .4, '--scene-gloss-x': (-85 + travel * 170) + '%',
      '--scene-gloss-opacity': Math.sin(travel * Math.PI) * .2, '--scene-glow': ease
    };
    for (let i = 0; i < 5; i++) {
      const show = clamp((progress - (.71 + i * .035)) / .08);
      values['--scene-line-' + (i + 1)] = show;
      values['--scene-label-' + (i + 1) + '-clip'] = (1 - show) * 100 + '%';
    }
    for (const [name, value] of Object.entries(values)) scene.style.setProperty(name, String(value));
    connectors(scene);
  }

  function orbitLayout(element, state) {
    const ring = ringScreen.matches && !staticMode();
    element.dataset.orbitLayout = ring ? 'ring' : 'list';
    if (!ring) return;
    const radius = Math.min(344, element.clientWidth / 2 - 122);
    state.cards.forEach((card, index) => {
      const angle = state.angle + index * Math.PI * 2 / state.cards.length - Math.PI / 2;
      card.style.setProperty('--orbit-x', (Math.cos(angle) * radius).toFixed(2) + 'px');
      card.style.setProperty('--orbit-y', (Math.sin(angle) * radius).toFixed(2) + 'px');
    });
  }

  function update(time = performance.now()) {
    frame = 0;
    if (document.hidden) { lastTime = 0; return; }
    const home = document.getElementById('hsx-home');
    if (!home) { lastTime = 0; return; }
    const delta = lastTime ? Math.min((time - lastTime) / 1000, .05) : 0;
    lastTime = time;
    const header = document.getElementById('shopify-section-hsx-original-header');
    const top = Math.round((header?.getBoundingClientRect().height || 80) + 12);
    home.style.setProperty('--home-sticky-top', top + 'px');
    let continuous = false;
    for (const scene of scenes) {
      if (!scene.isConnected) { scenes.delete(scene); continue; }
      const stage = scene.querySelector('.capsule-scene__sticky');
      if (!stage) continue;
      const staticScene = staticMode() || shortScreen.matches;
      scene.dataset.homeStatic = String(staticScene);
      if (staticScene) { paint(scene, 1); continue; }
      const rect = scene.getBoundingClientRect();
      if (rect.top > innerHeight + 100 || rect.bottom < -100) continue;
      paint(scene, clamp((top - rect.top) / Math.max(1, rect.height - stage.offsetHeight)));
    }
    for (const [element, state] of orbits) {
      if (!element.isConnected) { observer?.unobserve(element); orbits.delete(element); continue; }
      const active = ringScreen.matches && !staticMode() && state.visible && !state.hover && !element.contains(document.activeElement);
      if (active) { state.angle = (state.angle + delta * Math.PI * 2 / 130) % (Math.PI * 2); continuous = true; }
      orbitLayout(element, state);
    }
    if (continuous) frame = requestAnimationFrame(update);
    else lastTime = 0;
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(update); }

  function sync() {
    const home = document.getElementById('hsx-home');
    if (!home) return;
    home.dataset.homeMotion = staticMode() || document.hidden ? 'paused' : 'running';
    home.querySelectorAll('button[data-home-motion]').forEach(button => {
      button.hidden = reduced.matches;
      button.setAttribute('aria-pressed', String(paused()));
      button.textContent = paused() ? button.dataset.resume : button.dataset.pause;
    });
    if (staticMode() || document.hidden) for (const animation of animations) animation.finish();
    lastTime = 0;
    schedule();
  }

  function initialize(scope = document) {
    scope.querySelectorAll('#hsx-home [data-home-capsule-scene]').forEach(scene => {
      scenes.add(scene);
      scene.dataset.homeEnhanced = 'true';
    });
    scope.querySelectorAll('#hsx-home [data-lf-orbit]').forEach(element => {
      if (orbits.has(element)) return;
      const state = { cards: [...element.querySelectorAll('.lf-orbit__item')], angle: 0, hover: false, visible: !observer };
      orbits.set(element, state);
      element.addEventListener('pointerover', event => { state.hover = !!event.target.closest('.lf-orbit__item'); schedule(); });
      element.addEventListener('pointerleave', () => { state.hover = false; schedule(); });
      element.addEventListener('focusin', schedule);
      element.addEventListener('focusout', () => queueMicrotask(schedule));
      observer?.observe(element);
    });
    scope.querySelectorAll('#hsx-home .section-head, #hsx-home .milestone, #hsx-home .record-copy, #hsx-home .record-scene, #hsx-home .lf-areas__intro').forEach(element => {
      if (revealed.has(element)) return;
      revealed.add(element);
      if (!('IntersectionObserver' in window)) return;
      const entrance = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        entrance.disconnect();
        if (staticMode() || document.hidden || !element.animate) return;
        const animation = element.animate([{ opacity: .5, transform: 'translateY(16px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 800, easing: 'cubic-bezier(.22,.61,.36,1)' });
        animations.add(animation);
        animation.finished.then(() => animations.delete(animation)).catch(() => animations.delete(animation));
      }, { threshold: .12 });
      entrance.observe(element);
    });
    sync();
  }

  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    if (!target) return;
    if (target.closest('button[data-home-motion]')) {
      const shared = document.querySelector('button[data-sf-motion-toggle]');
      localPause = !paused();
      try { localStorage.setItem('hsx-motion', localPause ? 'paused' : 'running'); } catch (_) {}
      if (shared && (shared.getAttribute('aria-pressed') === 'true') !== localPause) shared.click();
      else if (!shared) root.dataset.sfMotion = localPause ? 'paused' : 'running';
      sync();
    }
    if (target.closest('a[href="#quality-facts"]')) {
      const facts = document.getElementById('quality-facts');
      if (facts) { event.preventDefault(); facts.scrollIntoView({ behavior: staticMode() ? 'auto' : 'smooth', block: 'start' }); facts.focus({ preventScroll: true }); }
    }
  });
  new MutationObserver(() => {
    if (!document.hidden && !reduced.matches) {
      try { localPause = localStorage.getItem('hsx-motion') === 'paused'; } catch (_) { localPause = root.dataset.sfMotion === 'paused'; }
    }
    sync();
  }).observe(root, { attributes: true, attributeFilter: ['data-sf-motion'] });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', schedule);
  document.addEventListener('visibilitychange', sync);
  reduced.addEventListener('change', sync);
  ringScreen.addEventListener('change', sync);
  shortScreen.addEventListener('change', sync);
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  document.fonts?.ready.then(schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
})();

;
/* END SOURCE assets/hsx-homepage-motion.js */
  }
  if (document.querySelector('#hsx-home')) {
    bootClassic();
  } else {
    function onSectionAdded(event) {
      const target = event.target;
      if (target && (target.id === 'hsx-home' || target.querySelector?.('#hsx-home'))) {
        document.removeEventListener('shopify:section:load', onSectionAdded);
        bootClassic();
      }
    }
    document.addEventListener('shopify:section:load', onSectionAdded);
  }
})();

/* BEGIN SOURCE assets/hsx-foundation-protocol.js */
/* Foundation Protocol scroll choreography */
(function () {
  var scenes = [];
  var framePending = false;

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function updateScene(scene) {
    if (reducedMotion()) return;

    var viewport = window.innerHeight || document.documentElement.clientHeight;
    var rect = scene.getBoundingClientRect();
    var raw = (viewport - rect.top) / (rect.height + viewport);
    var progress = Math.max(0, Math.min(1, (raw - 0.30) / 0.28));
    var label = Math.max(0, Math.min(1, (progress - 0.55) / 0.35));

    scene.style.setProperty('--scene-progress', progress.toFixed(3));
    scene.style.setProperty('--scene-x', (-40 + progress * 40).toFixed(2) + '%');
    scene.style.setProperty('--scene-y', (28 - progress * 28).toFixed(2) + '%');
    scene.style.setProperty('--scene-scale', (0.34 + progress * 0.66).toFixed(3));
    scene.style.setProperty('--scene-cell-opacity', (1 - progress).toFixed(3));
    scene.style.setProperty('--scene-cell-scale', (1 - progress * 0.28).toFixed(3));
    scene.style.setProperty('--scene-cell-blur', (progress * 1.1).toFixed(3) + 'rem');
    scene.style.setProperty('--scene-label-opacity', label.toFixed(3));
    scene.style.setProperty('--scene-line-scale', label.toFixed(3));
    scene.style.setProperty('--scene-disc-opacity', (0.35 + progress * 0.65).toFixed(3));
    scene.style.setProperty('--scene-disc-scale', (0.48 + progress * 0.52).toFixed(3));
    scene.style.setProperty('--scene-gloss-opacity', (progress * 0.9).toFixed(3));
    scene.style.setProperty('--scene-bloom-opacity', (0.28 + progress * 0.5).toFixed(3));
    scene.style.setProperty('--scene-bloom-scale', (0.72 + progress * 0.58).toFixed(3));
  }

  function updateAll() {
    framePending = false;
    scenes = scenes.filter(function (scene) {
      return document.documentElement.contains(scene);
    });
    scenes.forEach(updateScene);
  }

  function schedule() {
    if (framePending) return;
    framePending = true;
    window.requestAnimationFrame(updateAll);
  }

  function init(scope) {
    var found = scope.querySelectorAll
      ? scope.querySelectorAll('[data-hsx-foundation-scene]:not([data-hsx-foundation-ready])')
      : [];

    found.forEach(function (scene) {
      scene.dataset.hsxFoundationReady = '1';
      scenes.push(scene);
    });

    if (found.length) schedule();
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
})();
;
/* END SOURCE assets/hsx-foundation-protocol.js */

/* BEGIN SOURCE assets/hsx-pdp-fusion.js */
(() => {
  'use strict';
  if (window.hsxPdpFusionLoaded) return;
  window.hsxPdpFusionLoaded = true;
  const cleanups = new WeakMap();
  function mount(scope = document) {
    const pages = [...scope.querySelectorAll('.hsx-page--shop')];
    if (scope.matches?.('.hsx-page--shop')) pages.unshift(scope);
    pages.forEach(page => {
      if (cleanups.has(page)) return;
      const form = page.querySelector('#purchase-form');
      const hero = page.querySelector('#product');
      const nav = page.querySelector('.section-nav');
      if (!form || !hero || !nav) return;
      const dock = document.createElement('div');
      dock.className = 'hsx-pdp-dock';
      dock.hidden = true;
      const offer = document.createElement('span');
      const link = document.createElement('a');
      link.href = '#purchase-form';
      link.textContent = 'Choose your pack \u2191';
      dock.append(offer, link);
      page.append(dock);
      const media = window.matchMedia('(max-width: 900px)');
      const footer = document.querySelector('.hsx-footer, .site-footer');
      let heroVisible = true, footerVisible = false, observer, pendingFrame = 0;
      function visibility() {
        dock.hidden = !media.matches || heroVisible || footerVisible || hero.getBoundingClientRect().bottom >= 0;
      }
      function sync() {
        const price = form.querySelector('#price')?.textContent.trim() || '';
        const mode = form.querySelector('input[name="mode"]:checked')?.value;
        const label = page.querySelector('h1')?.textContent.trim() || '';
        offer.textContent = `${label} \u00b7 ${price}${mode === 'subscription' ? ' / shipment' : ''}`;
        const quantities = form.querySelector('#quantities');
        if (quantities) quantities.dataset.mode = mode || '';
      }
      const change = () => queueMicrotask(sync);
      form.addEventListener('change', change);
      link.addEventListener('click', event => {
        event.preventDefault();
        form.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
        const input = form.querySelector('input[name="mode"]:checked') || form.querySelector('input[name="mode"]');
        input?.focus({preventScroll:true});
      });
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.target === hero) heroVisible = entry.isIntersecting;
            if (entry.target === footer) footerVisible = entry.isIntersecting;
          });
          visibility();
        });
        observer.observe(hero);
        if (footer) observer.observe(footer);
      }
      media.addEventListener('change', visibility);
      const links = [...nav.querySelectorAll('a[href^="#"]')];
      function markLocation() {
        pendingFrame = 0;
        let active = null;
        links.forEach(anchor => {
          const section = page.querySelector(anchor.getAttribute('href'));
          if (section && section.getBoundingClientRect().top <= 180) active = anchor;
        });
        links.forEach(anchor => {
          if (anchor === active) anchor.setAttribute('aria-current','location');
          else anchor.removeAttribute('aria-current');
        });
      }
      const onScroll = () => { if (!pendingFrame) pendingFrame = requestAnimationFrame(markLocation); };
      window.addEventListener('scroll',onScroll,{passive:true});
      cleanups.set(page,() => {
        form.removeEventListener('change',change);
        media.removeEventListener('change',visibility);
        window.removeEventListener('scroll',onScroll);
        cancelAnimationFrame(pendingFrame);
        observer?.disconnect();
        dock.remove();
        cleanups.delete(page);
      });
      sync();
      markLocation();
    });
  }
  document.addEventListener('shopify:section:load',event => mount(event.target));
  document.addEventListener('shopify:section:unload',event => {
    event.target.querySelectorAll('.hsx-page--shop').forEach(page => cleanups.get(page)?.());
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => mount());
  else mount();
})();

;
/* END SOURCE assets/hsx-pdp-fusion.js */

/* BEGIN SOURCE assets/hsx-r1.js */
(() => {
  'use strict';
  if (window.hsxApprovedCopyReady) return;
  window.hsxApprovedCopyReady = true;
  function initialize(scope = document) {
    scope.querySelectorAll('.hsx-r1 .r1-table table').forEach(table => {
      if (table.dataset.r1Ready || table.closest('.r1-module--product-facts')) return;
      const headings = [...table.querySelectorAll('thead th')].map(cell => cell.textContent.trim());
      if (!headings.length) return;
      table.setAttribute('role', 'table');
      table.querySelectorAll('thead,tbody').forEach(group => group.setAttribute('role', 'rowgroup'));
      table.querySelectorAll('tr').forEach(row => row.setAttribute('role', 'row'));
      table.querySelectorAll('th').forEach(cell => cell.setAttribute('role', 'columnheader'));
      table.querySelectorAll('tbody tr').forEach(row => {
        [...row.cells].forEach((cell, index) => {
          cell.dataset.label = headings[index] || '';
          cell.setAttribute('role', 'cell');
        });
      });
      table.classList.add('r1-stacked-table');
      table.dataset.r1Ready = 'true';
    });
  }
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
})();

;
/* END SOURCE assets/hsx-r1.js */
